import { render, staticRenderFns } from "./DefaultRadio.vue?vue&type=template&id=3200ed2a&scoped=true"
import script from "./DefaultRadio.vue?vue&type=script&lang=js"
export * from "./DefaultRadio.vue?vue&type=script&lang=js"
import style0 from "./DefaultRadio.vue?vue&type=style&index=0&id=3200ed2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3200ed2a",
  null
  
)

export default component.exports